import React from "react";
import UserList from "./components/UserList";

const User = () => {
  return (
    <div>
      <UserList />
    </div>
  );
};

export default User;
